<template>
  <FlexCol gap-3>
    <Flex justify-end gap-3>
      <ButtonExport :api="route" name="Exportar Serviços Baixados" v-model:filters="osFilter" />
      <Button primary icon="fa-solid fa-plus" label="Adicionar Serviço" @click="openAddDialog" />
    </Flex>

    <TheTable :headers="headersService" :items="items" disablePagination :loader="loader" dense cell-border>
      <template #serviceName="{item}">
        <span v-if="item.serviceName">{{ item.serviceName }}</span>
        <span v-else class="italic"> Serviço Não Registrado </span>
      </template>
      <template #performedDate="{item}">
        <span v-if="item.performedDate">{{ formatFullDate(item.performedDate) }}</span>
      </template>

      <template #action="{item}">
        <Flex gap-2>
          <TheToolTip label="Editar">
            <TableIconButton icon="fa-pen" @click="openServiceDialog(item)" />
          </TheToolTip>
          <TheToolTip label="Excluir">
            <TableIconButton class="fa-trash" @click="openCancelDialog(item)" />
          </TheToolTip>
        </Flex>
      </template>
    </TheTable>

    <Modal title="Editar Serviços" v-model="dialogService" size="w-3/12">
      <template #default>
        <InputZoom
          v-model="objectService.idService"
          label="Service"
          database="service"
          itemText="name"
          itemValue="externalCode"
          required
          :error="errors.idService ? [errors.idService] : null"
          clearable
        />
      </template>
      <template v-slot:footer>
        <Button primary icon="fa-solid fa-save" label="Salvar" @click="save()" />
        <Button danger label="Cancelar" @click="cancelDialog" />
      </template>
    </Modal>

    <Modal title="Remover Serviço" v-model="dialogDelete" size="w-3/12">
      <template v-slot:default> Deseja remove o serviço? </template>
      <template v-slot:footer>
        <Button primary label="Remover" @click="removeAcept()" />
        <Button danger label="Cancelar" @click="cancelDialog" />
      </template>
    </Modal>
  </FlexCol>
</template>

<script setup>
import {computed, ref, onMounted, watch} from "vue"
import {get, insert, update, remove} from "@/crud"
import {useStore} from "vuex"
import {useFormat} from "@/composables/useFormat"

const {formatFullDate} = useFormat()

const props = defineProps({
  protocolo: String,
  idOs: Number,
})

const emits = defineEmits(["osServicesData"])
const store = useStore()

const route = "osService"
const dialogService = ref(false)
const dialogDelete = ref(false)
const objectService = ref(null)
const loader = ref(false)
const items = ref([])
const errors = ref({})

const headersService = [
  {title: "Data Execução", field: "performedDate", disableOrder: true},
  {title: "Serviço", field: "idService", width: "120px", disableOrder: true},
  {title: "Nome", field: "serviceName", disableOrder: true},
  {title: "Observação", field: "observation", disableOrder: true},
  {title: "Ações", field: "action", disableOrder: true},
]

// Computeds
const osFilter = computed(() => {
  return [{column: "protocolo", operator: "=", value: props.protocolo}]
})

// Dialogs
const openAddDialog = () => {
  errors.value = {}
  objectService.value = {}
  dialogService.value = true
}

const openServiceDialog = (service) => {
  errors.value = {}
  objectService.value = {...service}
  dialogService.value = true
}

const openCancelDialog = (service) => {
  objectService.value = service
  dialogDelete.value = true
}

const cancelDialog = () => {
  dialogService.value = false
  dialogDelete.value = false
}
// Apis

const loadItem = async () => {
  if (props.protocolo) {
    loader.value = true
    const query = {params: {filters: [{column: "protocolo", value: props.protocolo}]}}
    const response = await get(route, query)
    items.value = response.data

    emits("osServicesData", {
      headers: headersService,
      content: response.data,
    })
    loader.value = false
  }
}

const save = async () => {
  let response
  const id = objectService.value.id

  const object = {
    idOs: props.idOs,
    protocolo: props.protocolo,
    idService: objectService.value.idService,
  }

  if (id) {
    response = await update(route, id, object)
  } else {
    response = await insert(route, object)
  }
  errors.value = response.error ? response.data : {}
  if (!response.error) {
    if (id) {
      store.dispatch("setSuccess", {message: "Serviço alterado com sucesso"})
    }
    dialogService.value = false
    await loadItem()
  }
}

const removeAcept = async () => {
  const result = await remove(route, objectService.value.id)
  if (result && !result.error) {
    store.dispatch("setSuccess", {message: "Removido com Sucesso"})
  } else {
    store.dispatch("setError", {message: result.data})
  }
  await loadItem()
  cancelDialog()
}

//  Hooks
onMounted(() => {
  loadItem()
})

watch(
  props,
  () => {
    loadItem()
  },
  {deep: true}
)
</script>
